<template>
  <pt-production-task-list class="pt-production-task-list__withData" @getProductionTaskExportExcel="getProductionTaskExportExcel" :exportLoading="exportLoading" :hasDownload="true" @getProductionTaskDownloadExcel="getProductionTaskDownloadExcel" :downloadLoading="downloadLoading"></pt-production-task-list>
</template>

<script>
import PtProductionTaskList from './index'
export default {
  name: 'pt-production-task-list__withData',
  components: {
    'pt-production-task-list': PtProductionTaskList
  },
  data () {
    return {
      exportLoading: false,
      downloadLoading: false
    }
  },
  methods: {
    getProductionTaskDownloadExcel(params){
      let data={
        ...params
      }
      this.downloadLoading=true
      this.$store.dispatch('getProductionTaskDownloadExcel',data).then(res => {
        this.$message.success('生产任务下载成功')
        this.downloadLoading=false
      }).catch(err => {
        this.$message.error(err||'生产任务下载失败')
        this.downloadLoading=false
      })
    },
    getProductionTaskExportExcel (params) {
      let data = {
        ...params
      }
      this.exportLoading=true
      this.$store.dispatch('getProductionTaskExportExcel', data).then(res => {
        this.$message.success('生产任务导出成功')
        this.exportLoading = false
      }).catch(err => {
        this.$message.error(err || '生产任务导出失败')
        this.exportLoading = false
      })
    }
  }
}
</script>
